const product = {
  orderNow: 'Jetzt bestellen',
  detailsAndInfo: 'Details & Pflichtangaben',
  singlePrice: 'Single price',
  onlinePayment: 'Online payment',
  amount: 'Amount',
  total: 'Total',
  tabs: {
    description: 'Beschreibung',
    reviews: 'Produktbewertungen',
    downloads: 'Downloads',
    ratings: 'Product reviews',
  },
  pzn: 'PZN',
  manufacturer: 'Hersteller',
  brand: 'Marke',
  dosageForm: 'Darreichungsform',
  notes: 'Clarifying notes',
  offerer: 'Anbieter',
  packSize: 'Packungsgröße',
  basicPrice: 'Grundpreis',
  monopreparation: 'Monopräparat',
  contains: 'Enthält',
  activeIngredient: 'Wirkstoff',
  applicationAreas: 'Anwendungsgebiete',
  usageInstructions: 'Anwendungshinweise',
  operatingMode: 'Wirkungsweise',
  contraIndications: 'Gegenanzeigen',
  sideEffects: 'Nebenwirkungen',
  importantInstructions: 'Wichtige Hinweise',
  ingredients: 'Inhaltsstoffe',
  mandatoryInformation: 'Pflichtangaben',
  details: 'Details',
  volAlcohol: 'Vol.-% Alkohol.',
  gallery: {
    illustrationSimilar: 'Abbildung ähnlich',
    videoSupport: 'Your browser does not support the video tag.',
  },
  expressProduct: 'Express product',
  noOnlinePayment: 'No online payment',
  prescription: 'Prescription',
  maximumAmountReached: {
    zeroInCart: 'The maximum order quantity for the product has been reached due to drug law reasons.',
    oneInCart: 'This product is already in your shopping cart. The maximum order quantity for this product has been reached due to drug law reasons.',
    multipleInCart: 'This product is already in your shopping cart multiple times. The maximum order quantity for this product has been reached due to drug law reasons.',
  },
  rating: {
    averageRating: 'Average Rating',
    placeReview: 'Submit Review',
    noReviews: {
      title: 'This product has not yet received any customer reviews',
      description: 'Have you already used this product? Help others with their decision-making by being the first to share your experiences with this product.',
    },
    unknown: 'Unknown',
    alreadyRated: 'You have already rated this product. Another rating is not possible.',
    form: {
      title: 'Rate This Product',
      from: 'by',
      overallRating: 'Overall Rating *',
      package: 'Package Size • ',
      nameHint: 'This is how you will appear to other customers. You can also choose an abbreviation or leave the field blank.',
      terms: {
        1: 'By this, I confirm that I have actually received the rated product or have made an effort to obtain it. The rating is based on my personal experience. I have taken note of the',
        2: 'Terms of Use',
        3: 'and',
        4: 'Privacy Policy',
        5: 'and agree to their validity.',
      },
      mandatory: '* Please fill in the required fields',
      cancel: 'Cancel',
      send: 'Submit',
      titleError: 'Please select a title',
      descriptionError: 'Please provide a description',
      ratingError: 'Please provide an overall rating',
      authorLabel: 'Your public name',
      titleLabel: 'Title of the review *',
      descriptionLabel: 'Add a description *',
      note: 'Please note: It may take up to 24 hours for your review to be published.',
      thankYou: 'Thank you for your review. You have rated {productName} with {userRating} out of 5 stars.',
    },
    cancelModal: {
      title: 'Do you really want to discard your review?',
      description: 'Your review can help other customers with their purchase decision.',
      confirm: 'yes, discard',
      cancel: 'no',
    },
  },
  addItemInCart: 'Add one item in cart',
  removeItemFromCart: 'Remove one item from cart',
  productImage: 'Product image',
  couponDefaultText: 'You can find information about the coupon campaign {link}',
  couponTitle: 'Coupon-Information',
  couponLinkText: 'here',
}

export default product
